import { getDamage } from './damage'


export const isGraveObitoOrHasImageRisk = ({
    damageLevelValue,
    imageRiskValue
}: {
    damageLevelValue?: string
    imageRiskValue?: string
}) => {
    const canKindOfDamages = ['grave', 'obito']
    const damage = getDamage(damageLevelValue)
    const isKindOfDamage = canKindOfDamages.includes(damage?.value)
    const isImageRisk =
        imageRiskValue === 'true' || imageRiskValue === 'u_image_risk_yes'
    const isRequestedKind = isKindOfDamage || isImageRisk
    return isRequestedKind
}


export const hasAdverseEventsOrImageRisk = ({
    damageLevelValue,
    imageRiskValue
}: {
    damageLevelValue?: string
    imageRiskValue?: string
}) => {
    const canKindOfDamages = ['leve', 'moderado', 'grave', 'obito']
    const damage = getDamage(damageLevelValue)
    const isKindOfDamage = canKindOfDamages.includes(damage?.value)
    const isImageRisk = imageRiskValue === 'true' || imageRiskValue === 'u_image_risk_yes'

    return isKindOfDamage || isImageRisk
}


export const mustFilterByLocationsRoles = [
    'location_qa',
    'nsp',
    'unit_general_manager'
]

export const filterEventsForUsersLocation = (
    events: any[],
    localtionId: string
) => {
    return events.filter(
        (event) => event.location_incident.value === localtionId
    )
}
